export const getQuery = (keys) => {
  const params = new URLSearchParams(window.location.search);
  return keys.reduce((acc, key) => {
    acc[key] = params.get(key);
  }, {});
};
